let axios = window.axios
export default {
  /* 获取oss签名 */
  get_signature () {
    return axios.get('/addons/aliyunoss/api/index')
  },
  /* 上传至oss */
  oss_upload (url, file, params) {
    let formData = new FormData()
    for (let i in params) {
      formData.append(i, params[i])
    }
    formData.append('file', file)
    return axios({
      url: url,
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data;charset=UTF-8'
      },
      data: formData
    })
  }
}
